export enum StatusSubskrypcji {
  AKTYWNA = 'AKTYWNA',
  WYGASAJACA = 'WYGASAJĄCA',
  WYGASLA = 'WYGASŁA',
  ODWOLANA = 'ODWOŁANA',
  USUNIETA = 'USUNIĘTA',
  ZAMOWIONA = 'ZAMÓWIONA'
}
